import React from 'react';
import { ActivityIcon, ShieldCheckIcon } from 'lucide-react';
import { PRODUCT_PRICE, formatPrice } from '../data/config';
import { CtaButton } from './CtaButton';
import { ProductImage } from './ProductImage';
type FinalCTAProps = {
  guaranteeEnabled: boolean;
};
export function FinalCTA({
  guaranteeEnabled
}: FinalCTAProps) {
  return <section className="bg-blue-950 px-4 py-6 text-center md:px-12 md:py-8" data-id="element-58" data-mp="83vyhghzbu45">
      <h2 className="text-[24px] font-extrabold uppercase leading-[1.15] tracking-[-0.3px] text-amber-400 md:text-[29px]" data-id="element-59" data-mp="m3nhxwr9m2pj">
        One last question
      </h2>
      <p className="mx-auto mt-2 max-w-[580px] text-[16px] font-bold leading-[1.35] text-white md:text-[19px]" data-id="element-60" data-mp="vui3t00ln0ag">
        How often have you had to search through different references to organize rehabilitation for a patient after
        shoulder surgery?
      </p>
      <p className="mx-auto mt-2 max-w-[580px] text-[14px] leading-[1.45] text-blue-200 md:text-[15px]" data-id="element-61" data-mp="14tdbkgjakifv">
        A rotator cuff repair. A stabilization. A reverse replacement. A fracture. A tendon transfer. Keep gathering
        separate materials for every situation — or bring them together in one specialized clinical collection.
      </p>
      <p className="mt-2 text-[13px] font-extrabold uppercase text-amber-400 md:text-[14px]" data-id="element-62" data-mp="2m2b28hhwkp6j">
        Identify. Protect. Mobilize. Strengthen. Recover.
      </p>

      <div className="mx-auto mt-3 max-w-[240px]" data-id="element-63" data-mp="2qzuj7p5zjg26">
        <ProductImage data-id="element-64" data-mp="2v2hdrxu1jf32" />
      </div>

      <h3 className="mx-auto mt-2 max-w-[600px] text-[22px] font-extrabold uppercase leading-[1.1] tracking-[-0.3px] text-white md:text-[28px]" data-id="element-65" data-mp="2v3900i1r00go">
        <ActivityIcon className="mr-1.5 inline h-6 w-6 -translate-y-0.5 text-teal-300" strokeWidth={2.5} aria-hidden data-id="element-66" data-mp="34ssj9otdhwc2" />
        Complete Postoperative Shoulder Rehabilitation System™
      </h3>
      <p className="mx-auto mt-1 max-w-[600px] text-[11px] font-bold uppercase leading-tight text-white md:text-[12px]" data-id="element-67" data-mp="3errosyiudbuu">
        The complete postoperative shoulder rehabilitation resource collection for physical therapists
      </p>
      <p className="mt-1.5 text-[13px] font-extrabold uppercase text-teal-300 md:text-[14px]" data-id="element-68" data-mp="1jp4wbwirpbqi">
        7 Advanced Volumes + 5 FREE Professional Bonuses
      </p>
      <p className="mt-3 text-[13px] font-extrabold uppercase leading-tight text-white md:text-[14px]" data-id="element-69" data-mp="1sgeygc7uug6t">
        Get the complete collection today for just
      </p>
      <p className="mt-1 text-[42px] font-extrabold leading-none tracking-[-1px] text-amber-400 md:text-[50px]" data-id="element-70" data-mp="1nnu499l1e12r">
        {formatPrice(PRODUCT_PRICE)} <span className="text-[18px] tracking-normal text-white md:text-[20px]" data-id="element-71" data-mp="1xg9nsbbzexpr">USD</span>
      </p>
      <div className="mt-3" data-id="element-72" data-mp="2bg16uqhcv4am">
        <CtaButton mode="checkout" data-id="element-73" data-mp="2be7wb03mfzxc">Get instant access</CtaButton>
      </div>
      <p className="mt-2 text-[12px] font-semibold text-blue-200 md:text-[13px]" data-id="element-74" data-mp="27do48axwnmi2">
        Instant Digital Access{guaranteeEnabled && ' • 7-Day Money-Back Guarantee'}
      </p>
      <p className="mx-auto mt-1.5 max-w-[440px] text-[11px] font-bold uppercase leading-snug text-white md:text-[12px]" data-id="element-75" data-mp="d06b88eqdxfn">
        {guaranteeEnabled && <ShieldCheckIcon className="mr-1 inline h-3.5 w-3.5 -translate-y-px text-teal-300" aria-hidden data-id="element-76" data-mp="2whrcqyrgg2n" />}
        7 volumes + 5 FREE professional bonuses
      </p>
    </section>;
}